import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ForgeCreateInterface } from "../../../middleware/interfaces/forge/forge-create-interface";

export const ForgeCreate = {
  Create: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const forgeCreateData: ForgeCreateInterface = state.data;
      const url = "./php/forge/forge-creator-proxy.php";
      await axios
        .post(url, forgeCreateData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
